import { MdSearch } from 'react-icons/md';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  placeholder?: string;
}

const Input = ({ error, placeholder, ...rest }: Props) => {
  return (
    <div className="flex w-full flex-col">
      <div className="flex flex-row items-center rounded-lg border-[2px] border-solid border-[#E1E9EF] p-3 transition-all focus-within:border-[#0C1FAA]">
        <MdSearch size={24} className="text-[#727272]" />
        <input
          className={'h-[40px] w-full px-4 text-base text-[#373D43] outline-none'}
          {...rest}
          placeholder={placeholder}
        ></input>
      </div>
      {error && <span className="mt-1 text-xs text-red-500">{error}</span>}
    </div>
  );
};

export { Input };
